import type { NoteView } from '../types';
import { CANVAS } from '../theme';

import { Caption, FONT, frameProps } from './shared';

const PAD = 12;
const LINE_H = 20;
const WIDTH = 220;
const HEADER_H = 28;

export function NoteRenderer({ view }: { view: NoteView }) {
  const entries = Object.entries(view.attributes ?? {});
  const captionY = view.caption ? PAD + 8 : 0;
  const boxTop = view.caption ? PAD + 24 : 0;
  const height = boxTop + HEADER_H + entries.length * LINE_H + PAD;

  return (
    <svg {...frameProps(WIDTH, height, view.caption)}>
      <title>{view.caption ?? view.label}</title>
      {view.caption ? <Caption text={view.caption} x={PAD} y={captionY} /> : null}
      <rect
        x={PAD / 2}
        y={boxTop}
        width={WIDTH - PAD}
        height={height - boxTop - 4}
        rx={10}
        fill={CANVAS.cell}
        stroke={CANVAS.cellBorder}
        strokeWidth={1.5}
      />
      <text
        x={PAD}
        y={boxTop + HEADER_H / 2}
        fill={CANVAS.text}
        fontSize={FONT.value}
        fontWeight={700}
        dominantBaseline="central"
      >
        {view.label}
      </text>
      {entries.map(([key, value], i) => (
        <text
          key={key}
          x={PAD}
          y={boxTop + HEADER_H + i * LINE_H + LINE_H / 2}
          fill={CANVAS.textDim}
          fontSize={FONT.label}
          dominantBaseline="central"
        >
          {key}: {value}
        </text>
      ))}
    </svg>
  );
}

export default NoteRenderer;
